import styled from "styled-components";

export const Balloon = styled.div`
	padding: 0.25rem;
	font-size: 0.8rem;
	margin: 0;
	line-height: 1rem;
	background-color: var(--primaria-dark);
	color: white;
`